import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * TABHintBubble Component
 * Shows a hint bubble with Wyspur favicon prompting user to press TAB
 */
const TABHintBubble = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: -45,
        left: 0,
        bgcolor: 'rgba(0, 0, 0, 0.85)',
        color: 'white',
        px: 2,
        py: 1,
        borderRadius: 1,
        fontSize: '0.75rem',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        maxWidth: '200px',
        whiteSpace: 'nowrap',
        // Subtle animation entrance
        animation: 'fadeInScale 0.2s ease-out',
        '@keyframes fadeInScale': {
          '0%': {
            opacity: 0,
            transform: 'scale(0.9) translateY(5px)'
          },
          '100%': {
            opacity: 1,
            transform: 'scale(1) translateY(0)'
          }
        }
      }}
    >
      {/* Wyspur favicon */}
      <img 
        src="/favicon-16x16.png" 
        width="16" 
        height="16" 
        alt="Wyspur" 
        style={{ flexShrink: 0 }}
      />
      
      <Typography 
        variant="caption" 
        sx={{ 
          fontWeight: 500,
          fontSize: '0.75rem',
          lineHeight: 1
        }}
      >
        Press TAB to accept
      </Typography>
      
      {/* Small arrow pointing down to the field */}
      <Box
        sx={{
          position: 'absolute',
          bottom: -5,
          left: 16,
          width: 0,
          height: 0,
          borderLeft: '5px solid transparent',
          borderRight: '5px solid transparent',
          borderTop: '5px solid rgba(0, 0, 0, 0.85)'
        }}
      />
    </Box>
  );
};

export default TABHintBubble;